import {
  ChartsTypeEnum,
  type ICommonChartCard,
  type IScatterChartTab,
} from '../types';
import { GraphAxiesEnum, GraphNameEnum } from '../types/enums';

export const skeletonTabsSeoAndAds: IScatterChartTab[] = [
  {
    title: GraphNameEnum.sop,
    tooltip:
      'Отражает то, какую долю среди всех результатов поиска занимает тот или иной бренд. Пример: 36 позиций в результатах поиска, бренд А представлен 8-ю товарам - его доля 22.2%',
    key: 'SoP',
    description:
      'Средняя позиция - средняя из максимальных позиция товаров бренда (берется товар с наивысшей позицией). Доля позиций - Отражает то, какую долю среди всех результатов поиска занимает тот или иной бренд',
    data: [],
    labels: { x: GraphAxiesEnum.sop, y: GraphAxiesEnum.averagePositon },
  },
  {
    title: GraphNameEnum.soi,
    key: 'SoI',
    tooltip:
      'Отражает то, как часто товары бренда появляются на странице. Пример: было 10 проверок и товар нужного бренда появился только один раз (на любой позиции) - его видимость 10%',
    description:
      'Средняя позиция - средняя из максимальных позиция товаров бренда (берется товар с наивысшей позицией). Видимость - Отражает то, как часто товары бренда появляются на странице.',
    data: [],
    labels: { x: GraphAxiesEnum.soi, y: GraphAxiesEnum.averagePositon },
  },
  // {
  //   title: 'Average Position',
  //   key: 'Average Position',
  // },
];

export const skeletonTabOnlyAds: IScatterChartTab[] = [
  {
    title: GraphNameEnum.sop,
    tooltip:
      'Отражает то, какую долю среди всех рекламируемых результатов поиска занимает тот или иной бренд. Пример: в результатах поиска 8 рекламных позиций, бренду А из них принадлежит 2 товара - его доля 25%',
    key: 'SoP',
    description:
      'Доля позиций - Отражает то, какую долю среди всех рекламируемых результатов поиска занимает тот или иной бренд',
    data: [],
    labels: { x: GraphAxiesEnum.sop, y: '' },
  },
  {
    title: GraphNameEnum.soi,
    key: 'SoI',
    tooltip:
      'Отражает то, как часто товары бренда появляются среди рекламируемых товаров на странице. Пример: было 10 проверок и товар нужного бренда появился в рекламе только один раз (на любой позиции) - его видимость 10%',
    description:
      'Видимость - Отражает то, как часто товары бренда появляются среди рекламируемых товаров на странице',
    data: [],
    labels: { x: GraphAxiesEnum.soi, y: '' },
  },
  // {
  //   title: 'Average Position',
  //   key: 'Average Position',
  // },
];

export const skeletonCardsAllTime: ICommonChartCard = [
  {
    title: 'Весь Поиск',
    subtitle: 'Конкуренция',
    type: ChartsTypeEnum.scatter,
    tabs: skeletonTabsSeoAndAds,
  },
  {
    title: 'Только Реклама',
    subtitle: 'За все время',
    type: ChartsTypeEnum.treeMap,
    tabs: skeletonTabsSeoAndAds,
    isOnlyBrandshelf: true,
    isOnlyAds: true,
  },
];

export const skeletonCardsProgress: ICommonChartCard = [
  {
    title: 'Весь Поиск',
    subtitle: 'Прогресс',
    data: [],
    type: ChartsTypeEnum.line,
    tabs: [
      {
        title: GraphNameEnum.sop,
        tooltip:
          'Отражает то, какую долю среди всех результатов поиска занимает тот или иной бренд. Пример: 36 позиций в результатах поиска, бренд А представлен 8-ю товарам - его доля 22.2%',
        description:
          'Доля позиций - Отражает то, какую долю среди всех результатов поиска занимает тот или иной бренд',
        key: 'SoP',
        labels: { x: GraphAxiesEnum.date, y: GraphAxiesEnum.sop },
      },
      {
        title: GraphNameEnum.soi,
        description:
          'Видимость - Отражает то, как часто товары бренда появляются на странице.',
        tooltip:
          'Отражает то, как часто товары бренда появляются на странице. Пример: было 10 проверок и товар нужного бренда появился только один раз (на любой позиции) - его видимость 10%',
        key: 'SoI',
        labels: { x: GraphAxiesEnum.date, y: GraphAxiesEnum.soi },
      },
      {
        title: GraphAxiesEnum.averagePositon,
        key: GraphAxiesEnum.averagePositon,
        description:
          'Средняя позиция - средняя из максимальных позиция товаров бренда (берется товар с наивысшей позицией)',
        labels: { x: GraphAxiesEnum.date, y: GraphAxiesEnum.averagePositon },
      },
    ],
  },
  {
    title: 'Только Реклама',
    subtitle: 'Прогресс',
    data: [],
    type: ChartsTypeEnum.barStack,
    isOnlyBrandshelf: true,
    isOnlyAds: true,
    tabs: [
      {
        title: GraphNameEnum.sop,
        description:
          'Доля позиций - Отражает то, какую долю среди всех рекламируемых результатов поиска занимает тот или иной бренд',
        tooltip:
          'Отражает то, какую долю среди всех рекламируемых результатов поиска занимает тот или иной бренд. Пример: в результатах поиска 8 рекламных позиций, бренду А из них принадлежит 2 товара - его доля 25%',
        key: 'SoP',
        labels: { x: GraphAxiesEnum.date, y: GraphAxiesEnum.sop },
      },
      {
        title: GraphNameEnum.soi,
        key: 'SoI',
        tooltip:
          'Отражает то, как часто товары бренда появляются среди рекламируемых товаров на странице. Пример: было 10 проверок и товар нужного бренда появился в рекламе только один раз (на любой позиции) - его видимость 10%',
        description:
          'Видимость - Отражает то, как часто товары бренда появляются среди рекламируемых товаров на странице',
        labels: { x: GraphAxiesEnum.date, y: GraphAxiesEnum.soi },
      },
    ],
  },
];
